// Mock data for GrayMan Tech & Consultancy Portfolio

export const services = [
  {
    id: 1,
    title: "Web Application Development",
    description: "Build scalable, high-performance web applications using modern frameworks and cloud infrastructure. From MVPs to enterprise solutions.",
    features: ["React & Next.js", "Scalable Architecture", "Cloud Deployment", "API Development"]
  },
  {
    id: 2,
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications for iOS and Android. Beautiful interfaces with seamless user experiences.",
    features: ["iOS & Android", "React Native", "UI/UX Design", "App Store Launch"]
  },
  {
    id: 3,
    title: "Website Design & Development",
    description: "Professional websites that convert visitors into customers. Responsive, fast, and optimized for search engines.",
    features: ["Responsive Design", "SEO Optimized", "Fast Loading", "Modern UI/UX"]
  },
  {
    id: 4,
    title: "Custom Software Solutions",
    description: "Tailored software solutions that solve your unique business challenges. From automation to complex integrations.",
    features: ["Custom Development", "Integration Services", "Automation", "Maintenance"]
  },
  {
    id: 5,
    title: "Tech Consulting & Architecture",
    description: "Strategic technology consulting to help you make the right decisions. Architecture planning, tech stack selection, and more.",
    features: ["Tech Strategy", "Architecture Design", "Code Reviews", "Team Training"]
  },
  {
    id: 6,
    title: "Product Design & UX",
    description: "User-centered design that delights customers. From wireframes to high-fidelity prototypes and design systems.",
    features: ["UI/UX Design", "Prototyping", "Design Systems", "User Research"]
  }
];

// Portfolio section removed - will be added later as business grows
export const portfolio = [];

export const process = [
  {
    step: "01",
    title: "Discover",
    description: "We start by understanding your business goals, target audience, and technical requirements. Deep-dive workshops to align on vision and strategy."
  },
  {
    step: "02",
    title: "Design",
    description: "User-centered design process creating wireframes, prototypes, and high-fidelity designs. We validate with user testing before development."
  },
  {
    step: "03",
    title: "Build",
    description: "Agile development with regular sprints and demos. Clean, maintainable code following industry best practices and modern architecture patterns."
  },
  {
    step: "04",
    title: "Deploy",
    description: "Smooth launch with comprehensive testing, CI/CD pipelines, and production monitoring. We ensure zero-downtime deployments."
  },
  {
    step: "05",
    title: "Scale",
    description: "Post-launch support, performance optimization, and feature enhancements. We help you scale as your user base grows."
  }
];

export const techStack = [
  {
    category: "Frontend",
    technologies: ["React", "Angular", "Next.js", "Vue.js", "TypeScript", "Tailwind CSS"]
  },
  {
    category: "Backend",
    technologies: ["Node.js", "Python", "FastAPI", "GraphQL", "REST APIs"]
  },
  {
    category: "Mobile",
    technologies: ["React Native", "Flutter", "iOS", "Android", "Swift"]
  },
  {
    category: "Database",
    technologies: ["PostgreSQL", "MongoDB", "Redis", "Firebase", "MySQL"]
  },
  {
    category: "Cloud & DevOps",
    technologies: ["AWS", "Google Cloud", "Docker", "Kubernetes", "CI/CD"]
  },
  {
    category: "AI & Data",
    technologies: ["OpenAI"]
  }
];

// Testimonials removed - will be added as we grow our client base
export const testimonials = [];

export const whyChooseUs = [
  {
    title: "5 Years of Tech Experience",
    description: "Our team brings solid experience in delivering quality solutions across various industries."
  },
  {
    title: "Startup-Friendly Approach",
    description: "We understand the startup journey and offer flexible engagement models that work for your budget."
  },
  {
    title: "Quality-First Mindset",
    description: "Clean code, comprehensive testing, and modern architecture patterns are non-negotiable for us."
  },
  {
    title: "Long-Term Partnership",
    description: "We're not just developers – we're your technology partners invested in your long-term success."
  },
  {
    title: "Full-Stack Capability",
    description: "From design to deployment, we handle every aspect of your product development journey."
  },
  {
    title: "Transparent Communication",
    description: "Regular updates, clear timelines, and honest conversations throughout the entire project."
  }
];